/**
 *
 * Index
 *
 */
// import './wdyr';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import config from "./auth_config.json";
import HttpsRedirect from "react-https-redirect";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { CssBaseline } from "@material-ui/core";

// Toggle between real and mock Auth0 based on environment
const USE_MOCK_AUTH = process.env.REACT_APP_USE_MOCK_AUTH === "true";
const { Auth0Provider } = USE_MOCK_AUTH
  ? require("./mock-auth0-wrapper")
  : require("./react-auth0-wrapper");

console.log(`🔐 Auth Mode: ${USE_MOCK_AUTH ? "MOCK (Local Dev)" : "REAL (Auth0)"}`);

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState) => {
  // Temporary Firefox workaround
  window.location.hash = window.location.hash; // eslint-disable-line no-self-assign
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

Sentry.init({
  dsn:
    process.env.NODE_ENV === "production"
      ? "https://09c2e24b0681428b99332887ee6c35fa@o542587.ingest.sentry.io/5662563"
      : null,
  release: localStorage.getItem("app-version") || "no-version",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.1,
  ignoreErrors: ["ResizeObserver loop limit exceeded"],
});

// Conditionally pass props based on auth mode
const auth0Props = USE_MOCK_AUTH
  ? {} // Mock provider doesn't need config
  : {
      domain: config.domain,
      client_id: config.clientId,
      redirect_uri: window.location.origin,
      onRedirectCallback: onRedirectCallback,
    };

ReactDOM.render(
  <Auth0Provider {...auth0Props}>
    <HttpsRedirect>
      <CssBaseline />
      <App />
    </HttpsRedirect>
  </Auth0Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
